import { Ref, RefString, RefNumber, RefBool } from "@tblabs/truffle";
import { DiscountTarget } from "./DiscountTarget";
import { DiscountType } from "./DiscountType";
import { RawCost } from "./RawCost";


export abstract class Cost
{
    public Type = new Ref<DiscountType>(DiscountType.Percent);
    public Target = new Ref<DiscountTarget>(DiscountTarget.WholeBasket);
    public Code = new RefString();
    public Value = new RefNumber(0); // Percent or fixed price
    public IsOn = new RefBool(false);
    public IsVisible = new RefBool(true);
    public Name = new RefString();
    public Description = new RefString();
    public Limit = new RefNumber(0); // Max value in PLN when DiscountType.LimitedPercent is used

    constructor(raw?: RawCost)
    {
        this.Type.value = raw?.Type || DiscountType.Percent;
        this.Target.value = raw?.Target || DiscountTarget.WholeBasket;
        this.Name.value = raw?.Name || "";
        this.Code.value = raw?.Code || "";
        this.Value.value = raw?.Value || 0;
        this.IsVisible.value = raw?.IsVisible || false;
        this.Description.value = raw?.Description || "";
        this.Limit.value = raw?.Limit || 0;
    }

    public abstract CalcValue(price: number): number;
    public abstract AsString(price: number): string;

    public get AsRaw(): RawCost
    {
        return {
            Name: this.Name.value,
            Code: this.Code.value,
            Value: this.Value.value,
            Type: this.Type.value,
            Target: this.Target.value,
            IsVisible: this.IsVisible.value,
            Description: this.Description.value,
            Limit: this.Limit.value,
        };
    }
}
